import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Resources: ParentMenuProps = {
  label: 'Resources',
  description: 'Tools, insights, and advice',
  heapClass: 'topnav_resources_v',
  showcaseMobile: true,
  showcaseEntries: [
    {
      title: 'Free Tools and Templates',
      description:
        'Guides, e-books, and templates designed to help you run your restaurant business better.',
      heapClass: 'nav_freetools_v',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/free-tools-and-templates-thumnail.png',
      icon: 'before:content-icon-other-tech-tips',
      url: '/resources'
    },
    {
      title: 'Toast vs. Other POS',
      description:
        'See how Toast compares to Square, Clover, SpotOn, and more.',
      heapClass: 'nav_compare_v',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/2021Q3_Panini_The-Lexington_09-128x112.png',
      icon: 'before:content-icon-other-compare',
      url: '/compare'
    }
  ],
  subMenus: [
    {
      label: 'Industry Insights',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Trends and analysis from across the industry',
          heapClass: 'nav_otl_v',
          icon: 'before:content-icon-other-blog',
          url: '/blog/on-the-line'
        }
      ]
    },
    {
      label: 'Toast Support',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Resources to help you get the most out of Toast',
          heapClass: 'nav_toastcentral_v',
          icon: 'before:content-icon-other-tools-templates',
          url: 'https://support.toasttab.com/'
        }
      ]
    },
    {
      label: 'Customer Stories',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Restaurants of all kinds finding success with Toast',
          heapClass: 'nav_cxstories_v',
          icon: 'before:content-icon-solutions-back-of-house',
          url: '/customers'
        }
      ]
    },
    {
      label: 'Local Partner Advocates',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Get rewarded for helping restaurant clients succeed',
          heapClass: 'nav_partners_v',
          icon: 'before:content-icon-innovation',
          url: '/partners/register'
        }
      ]
    },
    {
      label: 'New Innovation at Toast',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label: 'Explore the latest features and updates for Spring 2025',
          heapClass: 'nav_innohub_v',
          icon: 'before:content-icon-advocates',
          url: '/innovation-hub/spring-2025'
        }
      ]
    },
    {
      label: 'Video Courses',
      showLabelMobile: false,
      subMenuEntryType: 'articles',
      subMenuEntries: [
        {
          label:
            "Learn something new today — whether you've got 5 minutes or 50.",
          heapClass: 'nav_video_v',
          icon: 'before:content-icon-other-courses',
          url: '/blog/learn'
        }
      ]
    }
  ]
}

export default Resources
